'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$31() {
  this.aLB = null;
  this.aLC = false;
}
export { $c_Lpresto_DashboardView$$anon$31 as $c_Lpresto_DashboardView$$anon$31 };
$p = $c_Lpresto_DashboardView$$anon$31.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$31;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$31() {
}
export { $h_Lpresto_DashboardView$$anon$31 as $h_Lpresto_DashboardView$$anon$31 };
$h_Lpresto_DashboardView$$anon$31.prototype = $p;
$p.P = (function() {
  if ((!this.aLC)) {
    this.aLB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T8($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aLC = true;
  }
  return this.aLB;
});
var $d_Lpresto_DashboardView$$anon$31 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$31, "presto.DashboardView$$anon$31", ({
  GX: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_DashboardView$$anon$31 as $d_Lpresto_DashboardView$$anon$31 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$31.js.map
